import component from './aside.vue'

export default component
